<template>
    <div class="ur-data-grid__content ur-full-grid__content--group-infi" :style="contStyle" ref="content">
        <div class="ur-data-grid__content__freeze-wrapper" :style="freezeStyle" ref="freezeWrapper"
                v-if="!!freezeWidth" @wheel="onWheelFixed">
            <group-node v-for="(r,i) in gridInfo.data" :data="r" :key="i" :pos-start="posStart" :pos-end="posEnd" freeze/>
        </div>
        <div class="ur-data-grid__content__scroll-wrapper" :style="scrollStyle" ref="scrollWrapper"
                @scroll="contScroll" @wheel="onWheelFixed">
            <group-node v-for="(r,i) in gridInfo.data" :data="r" :key="i" :pos-start="posStart" :pos-end="posEnd"/>
        </div>
        <!-- Vertical accordion -->
        <accrd-row :row="gridInfo.vars_accordionRow" vertical v-if="gridInfo.vars_accordionRow && isVertAcc"/>
        <!-- Pseudo scroll, please check also 'WrapperMixin', keep REF -->
        <p-scroll @on-scroll="onPseudoScroll" ref="pScroll"/>
        <!-- anchro for tooltip -->
        <div class="ur-data-grid__content__scroll-tooltip" :style="scrollStyle" ref="scrollTooltip"/>
    </div>
</template>

<script>
//[IMPORT] Sub components
import groupNode from './sub/urFullGridContentGroupNode.vue';
import accrdRow  from '../row/urDataGridContentAccordionRow.js';
import pScroll   from './sub/urDataGridContentPseudoScroll.vue';
//[IMPORT] Util mixin
import wrapperMixin from './mixin/urDataGridContentWrapperMixin';

export default {
    name : "urFullGridContentGroupInfi",
    inject : ['gridInfo'],
    mixins : [wrapperMixin],
    components : {groupNode, pScroll, accrdRow},
    data() {return {
        vScrollTop : 0,
        posStart : 0,
        posEnd   : 1,// not 0!
    }},
    computed : {
        // [COMPUTED][VARS] Variables

        freezeWidth() {
            this.$nextTick(()=>{
                // freeze 보이기 여부에 따라 freezeWrapper를 다시 설정해주어야만 scroll이 먹음.
                // 안 할 경우 div의 부모가 없어 scroolTop 을 줘도 먹지가 않음
                this.gridInfo.func.setRefs('freezeWrapper',this.$refs.freezeWrapper);
            })
            return this.gridInfo.vars_freezeWidth
        },
        // [COMPUTED][STYLE] Style of scroller
        scrollStyle() {return{
            "width"      :`calc(100% - ${this.freezeWidth}px)`,
            "margin-left":`${this.freezeWidth}px`
        }},
        // [COMPUTED][STYLE] Style of freeze scroller
        freezeStyle() {return {width:this.freezeWidth+'px'}},
        isVertAcc() {return this.gridInfo.vars_accordionVert},
    },
    mounted() {
        this.gridInfo.func.setRefs('content'      ,this.$refs.content);
        this.gridInfo.func.setRefs('scrollWrapper',this.$refs.scrollWrapper);
        this.gridInfo.func.setRefs('scrollTooltip',this.$refs.scrollTooltip);
        
        this.calcPosStart(0)
    },
    methods: {
        // [METHODS] Scroll control
        contScroll(event) {
            // 1. Calc scrollTop(n direction)
            // 1.1 get offset
            var el = this.$refs.scrollWrapper//, elRect = el.getBoundingClientRect();
            var offset = el.scrollTop;
            // 1.2 check render or not
            if(this.checkUpdate(offset)) {
                this.calcPosStart(offset)
            }
        },
        calcPosStart(offset) {
            // 0. prepare data
            // 0.0 before & after
            var prev = this.vScrollTop, next = offset;
            // 0.1 direction
            var direct = next > prev ? 'D' : 'U';
            // 0.2 height & buffer
            var el = this.$refs.scrollWrapper;
            var height = this.gridInfo.opts.height,
                rh = this.gridInfo.opts.rowHeight;
            if(el) {
                var elRect = el.getBoundingClientRect();
                height = elRect.height;
            }
            var buffer = height; // buffer  : same as height
            var padding = rh;    // padding : row height
            
            // 1. calc
            var ps = 0, pe = 0;
            if(direct === 'D') {
                // 1.1 downward
                ps = Math.max(0, next-padding);
                pe = next + height + buffer;
            } else {
                // 1.2 upward
                ps = Math.max(0,next-buffer);
                pe = next + height + padding;
            }
            
            // 2. set values
            this.posStart = ps
            this.posEnd   = pe
            this.vScrollTop = next;
        },
        checkUpdate(offset) {
            var ps = this.posStart, pe = this.posEnd;
            var el = this.$refs.scrollWrapper
            var height = this.gridInfo.opts.height;
            if(el) {
                var elRect = el.getBoundingClientRect();
                height = elRect.height;
            }
            return !(ps <= offset && offset+height <= pe);
        }
    },
}
</script>

